<ng-template #circleSkeleton>
    <ngx-skeleton-loader
        animation="progress-dark"
        [appearance]="'circle'"
        [theme]="skeletonConfig"
    ></ngx-skeleton-loader>
</ng-template>

<ng-template #rectangleSkeleton>
    <ngx-skeleton-loader animation="progress-dark" [theme]="skeletonConfig"></ngx-skeleton-loader>
</ng-template>

<ng-template #productListSkeleton>
    <div class="products-list-skeleton" aria-busy="true" aria-label="Loading products" role="status">
        @for (item of productListItems; track $index) {
            <ng-container *ngTemplateOutlet="productCardSkeleton"></ng-container>
        }
    </div>
</ng-template>

<ng-template #productCardsSkeleton>
    <div class="product-cards-skeleton" aria-busy="true" aria-label="Loading products" role="status">
        @for (item of productCardsItems; track $index) {
            <ng-container *ngTemplateOutlet="productCardSkeleton"></ng-container>
        }
    </div>
</ng-template>

<ng-template #productCardSkeleton>
    <div class="product-card-skeleton" aria-hidden="true">
        <div class="skeleton-block product-card-skeleton__image"></div>
        <div class="skeleton-block product-card-skeleton__line"></div>
        <div class="skeleton-block product-card-skeleton__line product-card-skeleton__line--medium"></div>
        <div class="skeleton-block product-card-skeleton__line product-card-skeleton__line--short"></div>
    </div>
</ng-template>
